import { render, staticRenderFns } from "./FloatingWhatsappButton.vue?vue&type=template&id=c012b768&scoped=true"
import script from "./FloatingWhatsappButton.vue?vue&type=script&lang=js"
export * from "./FloatingWhatsappButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c012b768",
  null
  
)

export default component.exports